class CartColorSelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    try {
      this.current = this.getAttribute("current") || null; 
      const variantsAttr = this.getAttribute("variants") || "[]";
      this.variants = JSON.parse(variantsAttr); 
    } catch (err) {
      console.error("❌ Failed to parse variants JSON:", err);
      this.variants = [];
    }

    this.render();

    this.removeEventListener("click", this._boundClickHandler || (() => {}));
    this._boundClickHandler = (e) => this.onColorClick(e);
    this.addEventListener("click", this._boundClickHandler);
  }

  render() {
    this.innerHTML = `
      <div class="t-flex t-gap-2">
        ${this.variants
          .map(
            (v) => `
            <button 
              type="button"
              class="color-swatch t-w-6 t-h-6 t-rounded-full ${
                v.color === this.current ? "active ring-2 ring-black" : ""
              }"
              data-variant-id="${v.id}"
              data-color="${v.color}"
              style="background-color:${v.color.toLowerCase()}"
              title="${v.color}">
            </button>
          `
          )
          .join("")}
      </div>
    `;
  }

  async onColorClick(e) {
    const target = e.target.closest("button[data-variant-id]");
    if (!target) return;

    const newVariantId = target.dataset.variantId;
    const newColor = target.dataset.color;
    const qtyInput = this.closest(".cart-item-card")?.querySelector(".quantity__input");
    const currentQty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    const line = this.dataset.line;

    this.querySelectorAll(".color-swatch").forEach((btn) =>
      btn.classList.remove("active", "ring-2", "ring-black")
    );
    target.classList.add("active", "ring-2", "ring-black");
    this.current = newColor;

    try {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: 0 }),
      });

      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: parseInt(newVariantId, 10), quantity: currentQty }),
      });

      if (!res.ok) {
        const errorText = await res.text();
        console.error("Add failed:", res.status, errorText);
        return;
      }

      const data = await res.json();

      this.render();

      const cartItems = document.querySelector("cart-items") || document.querySelector("cart-drawer-items");
      if (cartItems && typeof cartItems.onCartUpdate === "function") {
        cartItems.onCartUpdate();
      }

      document.dispatchEvent(new CustomEvent("cart:updated", { detail: data }));
    } catch (err) {
      console.error("Fetch failed:", err);
    }
  }
}

customElements.define("cart-color-selector", CartColorSelector);
